import { useNavigate } from "react-router-dom";
import { Eye, X } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

const ROLE_LABEL = { child: "kind", parent: "ouder", admin: "admin" };

export function ImpersonationBanner() {
  const { impersonating, user, stopImpersonating } = useAuth();
  const navigate = useNavigate();
  if (!impersonating || !user) return null;

  const stop = async () => {
    await stopImpersonating();
    navigate("/admin");
  };

  return (
    <div
      data-testid="impersonation-banner"
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[100] flex items-center gap-3 px-4 py-2.5 rounded-full bg-slate-900 text-white shadow-2xl border border-white/10"
    >
      <Eye className="w-4 h-4 text-amber-400 shrink-0" />
      <span className="text-sm font-semibold">
        Je bekijkt als <b>{user.name}</b> ({ROLE_LABEL[user.role] || user.role})
      </span>
      <button
        onClick={stop}
        data-testid="stop-impersonation-btn"
        className="ml-1 inline-flex items-center gap-1 px-3 py-1 rounded-full bg-amber-400 text-slate-900 text-xs font-bold hover:bg-amber-300 transition-colors"
      >
        <X className="w-3.5 h-3.5" /> Terug naar admin
      </button>
    </div>
  );
}
